<!--
 * @Descripttion: 带table列表的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 22:08:03
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-14 19:30:01
-->
<template>
	<div>
		<el-drawer
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="620"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content">
				<div class="filter-box pos-rela ml-16" style="height: auto">
					<el-input style="margin-right: 10px" placeholder="请输入" v-model="searchValue">
						<el-select v-model="selectOption" slot="prepend" placeholder="请选择" @change="changeSelect">
							<el-option :label="item.label" :value="item.value" v-for="item in dropdownList" :key="item.value"></el-option>
						</el-select>
					</el-input>
					<el-button class="searchBtn yx-color-white" @click="getList()">搜索</el-button>
				</div>
				<!-- 弹窗内容部分 -->
				<el-table
					class="mt-24"
					:data="list"
					header-row-class-name="table-header-row"
					row-class-name="table-row"
					v-loading="loading"
					@selection-change="handleSelectionChange"
				>
					<el-table-column type="selection" width="48"> </el-table-column>
					<el-table-column label="店铺名称" min-width="200">
						<template slot-scope="{ row }">
							<div class="flex-row flex-align-center">
								<platform-icon style="flex-shrink: 0" :platformId="row.platformId" />
								<span class="ml-4">{{ row.name }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="店铺ID" min-width="150">
						<template slot-scope="{ row }">
							<span>{{ row.outerShopId }}</span>
						</template>
					</el-table-column>
				</el-table>
				<yx-pagination
					:total="total"
					:current-page="pageInfo.page_index"
					:page-size="pageInfo.page_size"
					@size-change="sizeChange"
					@current-change="currentChange"
					:pager-count="5"
					:background="false"
				></yx-pagination>
			</div>
			<div class="drawer-footer yx-background-white">
				<el-button @click="handleClose">取 消</el-button>
				<el-button @click="confirm" type="primary" :loading="btnLoading" :disabled="isDisabled">添 加</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { cooperativeShopList, institutionAddShop } from '@/api/cooperativeShop';

export default {
	components: {},
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	computed: {
		isDisabled({ selectionList }) {
			return !selectionList.length;
		},
	},
	data() {
		return {
			title: '添加店铺', // 弹窗标题
			visible: false, // 弹窗显隐
			list: [], // 列表数据
			total: 0, // 列表总数
			pageInfo: {
				page_index: 1, // 页码
				page_size: 20, // 每页条数
			},
			selectOption: 0,
			dropdownList: [
				{
					value: 0,
					label: '店铺名称',
					key: 'name',
				},
				{
					value: 1,
					label: '店铺ID',
					key: 'outerShopId',
				},
			],
			loading: false, // 表格加载状态
			searchValue: '',
			selectionList: [],
			btnLoading: false,
		};
	},

	created() {
		this.initData();
	},
	methods: {
		// 主动显示弹窗
		show() {
			this.visible = true;
			this.getList();
		},
		//获取列表
		async getList() {
			this.loading = true;

			const { platformId, pageInfo, selectOption, searchValue } = this;
			let key = this.dropdownList.find(item => item.value === selectOption).key;
			let params = { [key]: searchValue };
			try {
				const { list = [], page = {} } = await cooperativeShopList({ ...pageInfo, ...params, platformId });
				this.list = list;
				this.total = `${page.itemTotal}`;
			} finally {
				this.loading = false;
			}
		},
		async confirm() {
			const { platformId } = this;
			const shopIds = this.selectionList.map(item => item.outerShopId);
			this.btnLoading = true;
			try {
				await institutionAddShop({ platformId, shopIds });
				this.handleClose();
				this.$emit('refresh');
				this.$message.success('添加成功！');
			} finally {
				this.btnLoading = false;
			}
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			this.total = 0;
			this.pageInfo = {
				page_index: 1,
				page_size: 20,
			};
			this.btnLoading = false;
			this.selectionList = [];
			this.selectOption = 0;
			this.searchValue = '';
			this.loading = false;
			// 关闭弹窗
			this.visible = false;
		},
		changeSelect(e) {
			this.searchValue = '';
		},
		handleSelectionChange(val) {
			this.selectionList = val;
		},
		// 每页展示条数变化
		sizeChange(val) {
			this.pageInfo.page_size = val;
			this.getList();
		},
		// 页数变化
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.getList();
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.content {
	::v-deep .el-input__inner {
		border-radius: 0px !important;
	}
	.filter-box {
		.el-select {
			width: 100px;
		}
		/deep/ .el-input-group__prepend {
			background-color: @color-white;
			border: 1px solid #e2e3e8;
			border-right: none;
			border-top-left-radius: 4px;
			border-bottom-left-radius: 4px;
			.el-input__inner {
				border: none !important;
			}
		}
	}
	.searchBtn {
		width: 56px;
		background-color: @color-primary;
		font-size: 13px;
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
		position: absolute;
		right: 0;
		top: 0px;
		border: 1px solid @color-primary;
	}
	::v-deep .el-radio {
		margin-right: 10px;
	}
}
.drawer-footer {
	z-index: 999;
}
</style>
